import Checkbox from '@ben/orion/checkbox';
import type { IModularBenefitDetail } from '@ben/shared/types/columbia';
import { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { EnrollmentDateType } from './date-type-selector';

interface ResetEnrollmentsOnEndDateProps {
  endDateType?: EnrollmentDateType;
}

export const ResetEnrollmentsOnEndDate = ({
  endDateType,
}: ResetEnrollmentsOnEndDateProps) => {
  const { control, getValues, setValue } =
    useFormContext<IModularBenefitDetail>();

  useEffect(() => {
    const enrollmentConfig = getValues('enrollmentConfig');
    if (endDateType === EnrollmentDateType.NONE && enrollmentConfig) {
      setValue('enrollmentConfig.resetEnrollmentsOnEndDate', false);
    }
    // Initially the value is null, which is not acceptable
    if (enrollmentConfig?.resetEnrollmentsOnEndDate === null) {
      setValue('enrollmentConfig.resetEnrollmentsOnEndDate', false);
    }
  }, [endDateType, getValues, setValue]);

  return (
    <Controller
      name="enrollmentConfig.resetEnrollmentsOnEndDate"
      control={control}
      render={({ field }) => {
        return (
          <Checkbox
            label="Reset enrollments on end date"
            {...field}
            value={field.value || false}
            disabled={endDateType === EnrollmentDateType.NONE}
          />
        );
      }}
    />
  );
};
